import * as React from "react";
import { PackagePartialStayProps } from "components/flexComponents/WizardPackagePWA/typings";
import { observer } from "mobx-react";
import { UitkCheckbox } from "uitk-react-switch";
import { UitkLayoutGridItem } from "uitk-react-layout-grid";
import { useLocalization } from "@shared-ui/localization-context";

export const PackagePartialStay = observer((props: PackagePartialStayProps) => {
  const { formatText } = useLocalization();

  return (
    <UitkLayoutGridItem colSpan="all">
      <div>
        <UitkCheckbox
          id="package-partial-stay"
          onChange={props.togglePartialStay}
          checked={props.packageWizardState.partialStay}
        >
          {formatText(props.partialStayAccommodationLabel)}
        </UitkCheckbox>
      </div>
    </UitkLayoutGridItem>
  );
});
